import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  errorMessage?: string;
  label?: string;
  labelClassName?: string;
}

export const Input: React.FC<InputProps> = ({
  error = false,
  errorMessage,
  label,
  labelClassName = '',
  className = '',
  ...props
}) => {
  const baseStyles =
    'w-full bg-white/5 rounded-lg border px-4 py-2.5 text-sm text-white transition-all focus:outline-none focus:bg-white/8 focus:ring-2 focus:ring-[#3b82f6]/10 placeholder:text-white/30';
  
  const errorStyles = error
    ? 'border-[#fca5a5] focus:border-[#fca5a5]/50'
    : 'border-white/10 focus:border-[#3b82f6]/50';

  const inputElement = (
    <input
      className={`${baseStyles} ${errorStyles} ${className}`}
      {...props}
    />
  );

  if (label) {
    return (
      <div>
        <label className={`block mb-2 ${labelClassName}`}>
          {typeof label === 'string' ? (
            <div className="text-sm text-white/50 mb-1">{label}</div>
          ) : (
            label
          )}
          {inputElement}
        </label>
        {error && errorMessage && (
          <div className="text-[#fca5a5] text-xs mt-1">{errorMessage}</div>
        )}
      </div>
    );
  }

  return (
    <div>
      {inputElement}
      {error && errorMessage && (
        <div className="text-[#fca5a5] text-xs mt-1">{errorMessage}</div>
      )}
    </div>
  );
};

